export default __webpack_public_path__ + "assets/images/0f8ce1c14302bac5ce715ecd9cf16340.png";